/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ScoreTiss_28ViewerAliases {
  ACTION_INACTIVATE_SCORE_TISS_28 = 'action-inactivate-score-tiss-28',
  ACTION_NEW_SCORE_TISS_28 = 'action-new-score-tiss-28',
  ACTION_REFERENCE_SCORE_TISS_28 = 'action-reference-score-tiss-28',
  CHECKBOX_ACIDOSIS = 'checkbox-acidosis',
  CHECKBOX_ACTIVE_DIURESIS = 'checkbox-active-diuresis',
  CHECKBOX_ARTIFICIAL_AIRWAY = 'checkbox-artificial-airway',
  CHECKBOX_CARDIO_RESSUSCITATION = 'checkbox-cardio-ressuscitation',
  CHECKBOX_CAT_ART_PERIPHERAL = 'checkbox-cat-art-peripheral',
  CHECKBOX_CENTRAL_VENOUS = 'checkbox-central-venous',
  CHECKBOX_DRAIN = 'checkbox-drain',
  CHECKBOX_ENT_NUTRI = 'checkbox-ent-nutri',
  CHECKBOX_FREQ_DRESSINGS = 'checkbox-freq-dressings',
  CHECKBOX_INTRACRANIAL_PRESSURE = 'checkbox-intracranial-pressure',
  CHECKBOX_INTRAVENOUS_MED = 'checkbox-intravenous-med',
  CHECKBOX_LAB = 'checkbox-lab',
  CHECKBOX_MECH_VENT = 'checkbox-mech-vent',
  CHECKBOX_MONIT_ATRIUM = 'checkbox-monit-atrium',
  CHECKBOX_MULTI_ICU = 'checkbox-multi-icu',
  CHECKBOX_MULTIVASO_MED = 'checkbox-multivaso-med',
  CHECKBOX_OUT_ICU = 'checkbox-out-icu',
  CHECKBOX_PAREN_NUTRI = 'checkbox-paren-nutri',
  CHECKBOX_REPO_VOL = 'checkbox-repo-vol',
  CHECKBOX_ROUTINE_DRESSINGS = 'checkbox-routine-dressings',
  CHECKBOX_STANDARD_MONIT = 'checkbox-standard-monit',
  CHECKBOX_SUP_VENT_SUPPORT = 'checkbox-sup-vent-support',
  CHECKBOX_TECH_HEMOFILTRATION = 'checkbox-tech-hemofiltration',
  CHECKBOX_TRAT_PULMONAR = 'checkbox-trat-pulmonar',
  CHECKBOX_UNIQUE_ICU = 'checkbox-unique-icu',
  CHECKBOX_UNIQUE_MEDICATION = 'checkbox-unique-medication',
  CHECKBOX_URINE_DEBIT = 'checkbox-urine-debit',
  CHECKBOX_VASO_MED = 'checkbox-vaso-med',
  CONTEXTUAL_BAR = 'contextual-bar',
  FIELD_ACIDOSIS = 'field-acidosis',
  FIELD_ACTIVE_DIURESIS = 'field-active-diuresis',
  FIELD_ARTIFICIAL_AIRWAY = 'field-artificial-airway',
  FIELD_BASIC_ACTIVITIES = 'field-basic-activities',
  FIELD_CARDIO_RESSUSCITATION = 'field-cardio-ressuscitation',
  FIELD_CARDIO_SUPPORT = 'field-cardio-support',
  FIELD_CAT_ART_PERIPHERAL = 'field-cat-art-peripheral',
  FIELD_CENTRAL_VENOUS = 'field-central-venous',
  FIELD_CLASSIFICATION = 'field-classification',
  FIELD_DRAIN = 'field-drain',
  FIELD_ENT_NUTRI = 'field-ent-nutri',
  FIELD_EVALUATION_DATE = 'field-evaluation-date',
  FIELD_FREQ_DRESSINGS = 'field-freq-dressings',
  FIELD_HOUR = 'field-hour',
  FIELD_INTRACRANIAL_PRESSURE = 'field-intracranial-pressure',
  FIELD_INTRAVENOUS_MED = 'field-intravenous-med',
  FIELD_KIDNEY_SUPPORT = 'field-kidney-support',
  FIELD_LAB = 'field-lab',
  FIELD_MECH_VENT = 'field-mech-vent',
  FIELD_METABOLIC_SUPPORT = 'field-metabolic-support',
  FIELD_MONIT_ATRIUM = 'field-monit-atrium',
  FIELD_MULTI_ICU = 'field-multi-icu',
  FIELD_MULTIVASO_MEDI = 'field-multivaso-medi',
  FIELD_NEURO_SUPPORT = 'field-neuro-support',
  FIELD_OUT_ICU = 'field-out-icu',
  FIELD_PAREN_NUTRI = 'field-paren-nutri',
  FIELD_PROFESSIONAL = 'field-professional',
  FIELD_PUNCTUATION = 'field-punctuation',
  FIELD_REPO_VOL = 'field-repo-vol',
  FIELD_ROUTINE_DRESSINGS = 'field-routine-dressings',
  FIELD_SPEC_INTERV = 'field-spec-interv',
  FIELD_STANDARD_MONIT = 'field-standard-monit',
  FIELD_SUP_VENT_SUPPORT = 'field-sup-vent-support',
  FIELD_TECH_HEMOFILTRATION = 'field-tech-hemofiltration',
  FIELD_TRAT_PULMONAR = 'field-trat-pulmonar',
  FIELD_UNIQUE_ICU = 'field-unique-icu',
  FIELD_UNIQUE_MEDICATION = 'field-unique-medication',
  FIELD_URINE_DEBT = 'field-urine-debt',
  FIELD_VASO_MEDI = 'field-vaso-medi',
  FIELD_VENT_SUPPORT = 'field-vent-support',
  FORM_SCORE_TISS_28_VIEWER = 'form-score-tiss-28-viewer',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  INPUT_EVATUALION_DATE = 'input-evatualion-date',
  INPUT_HOUR = 'input-hour',
  LAYOUT_SCORE_TISS_28_VIEWER = 'layout-score-tiss-28-viewer',
  TEXT_BASIC_ACTIVITIES = 'text-basic-activities',
  TEXT_CARDIO_SUPPORT = 'text-cardio-support',
  TEXT_CLASSIFICATION = 'text-classification',
  TEXT_KIDNEY_SUPPORT = 'text-kidney-support',
  TEXT_METABOLIC_SUPPORT = 'text-metabolic-support',
  TEXT_NEURO_SUPPORT = 'text-neuro-support',
  TEXT_PROFESSIONAL = 'text-professional',
  TEXT_PUNCTUATION = 'text-punctuation',
  TEXT_SPEC_INTERV = 'text-spec-interv',
  TEXT_VENT_SUPPORT = 'text-vent-support',
}
export { ScoreTiss_28ViewerAliases };
